import React from 'react'

const GeneralInfo = ({
    nextOfKinInfo,
    handleNextOfKinInfoChange,
    emergencyContactInfo,
    handleEmergencyContactInfoChange
}) => {
  return (
    <div className="member-form-section">
        <div className="bg-primary text-secondary px-5 py-2">GENERAL INFORMATION</div>
        <div className="member-form-body">
          <div className="member-form-details">
            {/* FIRST ROW */}
            <div className="grid lg:grid-cols-3 gap-5 p-5">
              {/* NAME OF SPOUSE */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Next of Kin<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="next_of_kin"
                  id="next_of_kin"
                  onChange={(e) => handleNextOfKinInfoChange(e)}
                  value={nextOfKinInfo?.next_of_kin}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/*RELATIONSHIP */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Relationship<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="relationship"
                  id="relationship"
                  onChange={(e) => handleNextOfKinInfoChange(e)}
                  value={nextOfKinInfo?.relationship}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/*NOK ADDRESS*/}
              <div className="flex flex-col">
                <label htmlFor="">
                  Next of Kin Address<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="address_of_nok"
                  id="address_of_nok"
                  onChange={(e) => handleNextOfKinInfoChange(e)}
                  value={nextOfKinInfo?.address_of_nok}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* NOK CONTACT NUMBER */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Next Of Kin Contact Number<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="nok_contact_number"
                  id="nok_contact_number"
                  onChange={(e) => handleNextOfKinInfoChange(e)}
                  value={nextOfKinInfo?.nok_contact_number}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* EMERGENCY CONTACT PERSON */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Emergency Contact Person (ECP)<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="emergency_contact_person"
                  id="emergency_contact_person"
                  onChange={(e) => handleEmergencyContactInfoChange(e)}
                  value={emergencyContactInfo?.emergency_contact_person}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* EMERGENCY CONTACT PERSON'S RELATIONSHIP*/}
              <div className="flex flex-col">
                <label htmlFor="">
                  ECP Relationship
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="emergency_person_relationship"
                  id="emergency_person_relationship"
                  onChange={(e) => handleEmergencyContactInfoChange(e)}
                  value={emergencyContactInfo?.emergency_person_relationship}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
            </div>
           
           
            {/* FOURTH ROW */}
            <div className="grid lg:grid-cols-3 gap-5 pt-0 p-5">
              {/* EMERGENCY CONTACT PERSON ADDRESS */}
              <div className="flex flex-col">
                <label htmlFor="">
                  ECP Address
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="emergency_contact_person_address"
                  id="emergency_contact_person_address"
                  onChange={(e) => handleEmergencyContactInfoChange(e)}
                  value={emergencyContactInfo?.emergency_contact_person_address}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* EMERGENCY CONTACT PERSON'S CONTACT*/}
              <div className="flex flex-col">
                <label htmlFor="">
                  {" "}
                  ECP Contact Number<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="emergency_person_contact"
                  id="emergency_person_contact"
                  onChange={(e) => handleEmergencyContactInfoChange(e)}
                  value={emergencyContactInfo?.emergency_person_contact}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default GeneralInfo